import React from "react";
import Image from "next/image";
import { ORCID_ICON } from "@/src/constant/constant";
import { Typography } from "@mui/material";
import Link from "@mui/material/Link";
import NextLink from "@mui/material/Link";

interface AuthorProps {
  author: Author;
}

const Author: React.FC<AuthorProps> = ({ author }) => {
  return (
    <Typography
      component={"span"}
      sx={{ fontSize: "inherit", color: "inherit" }}
    >
      {author.first_name} {author.last_name}
      {author.orcid && (
        <Link
          component={NextLink}
          href={`http://orcid.org/${author.orcid}`}
          rel={"noopener noreferrer"}
          target={"_blank"}
        >
          <Image
            style={{
              marginLeft: ".25rem",
              verticalAlign: "text-bottom",
            }}
            src={ORCID_ICON}
            alt={"ORCID"}
            width={"15"}
            height={"15"}
            title={"ORCID"}
          />
        </Link>
      )}
      {author.correspond && (
        <Typography
          sx={{
            top: "-0.5em",
            left: ".15rem",
            position: "relative",
            fontSize: ".75em",
            lineHeight: "0",
            verticalAlign: "baseline",
            color: "inherit",
          }}
          component="sup"
        >
          {author.correspondence_label}
        </Typography>
      )}
    </Typography>
  );
};

export default Author;
